import React from 'react';
import { Alert, AlertTitle, List, ListItem, ListItemText } from '@mui/material';
import responseErrorMapping from '../../utils/error.response.mapping';

export default function ErrorFormAlert(props) {
  const { data } = props;

  return (
    <div style={{ width: '600px' }}>
      <Alert
        severity='error'
        sx={{
          backgroundColor: '#FFE6E1',
          border: '2px solid red',
          color: 'red',
          borderRadius: '3px',
        }}
      >
        <AlertTitle>Form Submission Errors</AlertTitle>

        <List sx={{ p: 0 }}>
          {data.map((err, index) => (
            <ListItem key={index} disableGutters sx={{ p: 0, m: 0 }}>
              <ListItemText
                sx={{ m: 0 }}
                primary={`• ${responseErrorMapping(err.errorMessage)}`}
                primaryTypographyProps={{
                  sx: {
                    color: 'red',
                    letterSpacing: '0.5px',
                    fontFamily: 'Inter Regular',
                    fontSize: '14px',
                    m: 0,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Alert>
    </div>
  );
}
